import { all, call, put, take } from 'redux-saga/effects';

import api from 'api';
import { IPersonalPlanResponse } from 'api/components/PersonalPlan/types';

import { notifyError } from 'store/notifications/actions';
import {
    generatePlanRequest,
    getCurrentPlanError,
    getCurrentPlanSuccess,
    joinBranchContentRequest,
    setCurrentPlanCompletion,
} from 'store/personalPlan/actions';
import { waitForGetUserPersonalisation } from 'store/user/sagas/helpers';

import { addWorkoutStatus } from 'helpers/personalPlan';
import { isWholePlanCompleted } from 'helpers/workout';

import { JOIN_BRANCH_CONTENT_FINISHED } from '../actionTypes';

import { getWorkout } from './getWorkout';

export function* getCurrentPlan() {
    const joinedFromStorage = localStorage.getItem('joinedBranchContent');

    if (!joinedFromStorage) {
        yield put(joinBranchContentRequest());
        yield take(JOIN_BRANCH_CONTENT_FINISHED);

        localStorage.setItem('joinedBranchContent', 'true');
    }

    try {
        const [{ id, current_day, days, yoga_type, plan_type, instructor }]: [IPersonalPlanResponse] = yield all([
            call(api.personalPlan.getCurrentPersonalPlan),
            call(waitForGetUserPersonalisation),
        ]);

        const { workouts, availableCurrentDay } = addWorkoutStatus({ days, currentDay: current_day });

        yield put(
            getCurrentPlanSuccess({
                id,
                current_day: availableCurrentDay,
                days: workouts,
                yoga_type,
                plan_type,
                instructor,
            })
        );

        if (isWholePlanCompleted(workouts)) yield put(setCurrentPlanCompletion(true));

        yield call(getWorkout);
    } catch (error: any) {
        if (error.response?.status === 404) {
            yield put(generatePlanRequest());
        } else {
            yield put(getCurrentPlanError());
            yield put(notifyError({ message: 'basics.appError' }));
        }
    }
}
